import React from "react";
import { Card, CardBody } from "reactstrap";
import classNames from "classnames";
import { getTheme2SearchFilterFieldCss } from "utils/theme2MultiSelect";
import { getStickyStockTableStickyColumnCss } from "utils/reactTableTheme";

const SEARCH_REPORTS_PAGE_STYLES = (isTheme2) => `
  ${isTheme2 ? `
  .search-reports.search-reports--theme2 .search-reports-table-card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
    padding-left: 0;
  }
  ${getTheme2SearchFilterFieldCss({
    pageScopeSelector: ".search-reports.search-reports--theme2",
    filtersSelector: ".search-reports-table-card .search-reports-filters",
    rowClass: "search-reports-filters-row",
    colClass: "search-reports-filter-col",
  })}
  .search-reports.search-reports--theme2 .search-reports-filters-row {
    column-gap: 4px;
  }
  .search-reports.search-reports--theme2 .search-reports-filter-col {
    padding-left: 4px;
    padding-right: 4px;
  }
  .search-reports.search-reports--theme2 .search-reports-filter-col:first-child {
    padding-left: 0;
  }
  .search-reports .search-reports-filters-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 12px 16px;
    width: 100%;
    margin-bottom: 12px;
    padding-top: 4px;
  }
  .search-reports .search-reports-filter-field {
    flex: 0 1 280px;
    min-width: 200px;
    max-width: 320px;
    margin-bottom: 0 !important;
  }
  .search-reports .search-reports-filter-field .form-control {
    min-height: 38px;
    height: 38px;
  }
  .search-reports .search-reports-filter-field .react-select__control {
    min-height: 38px !important;
    height: 38px !important;
  }
  .search-reports .search-reports-filter-field .react-select__value-container {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .search-reports .search-reports-filter-field .react-select__indicators {
    height: 38px;
  }
  .search-reports .search-reports-filter-field label,
  .search-reports .search-reports-filter-actions label {
    display: block;
    margin-bottom: 4px;
    line-height: 1.2;
    min-height: 1.2em;
  }
  .search-reports .search-reports-filter-actions {
    margin-left: auto;
    margin-bottom: 0 !important;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    flex: 0 0 auto;
  }
  .search-reports .search-reports-filter-actions__spacer {
    visibility: hidden;
    user-select: none;
    display: block;
    margin-bottom: 4px;
    line-height: 1.2;
    min-height: 1.2em;
  }
  .search-reports .search-reports-filter-actions__btn {
    display: flex;
    align-items: center;
    height: 38px;
  }
  .search-reports .search-reports-filter-actions__btn .btn {
    margin: 0;
    height: 38px;
    display: inline-flex;
    align-items: center;
  }
  ` : ""}
  .search-reports:not(.search-reports--theme2) .search-reports-filters-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 12px 16px;
    width: 100%;
    margin-bottom: 12px;
    padding-top: 4px;
  }
  .search-reports:not(.search-reports--theme2) .search-reports-filter-field {
    flex: 0 1 280px;
    min-width: 200px;
    max-width: 320px;
  }
  .search-reports:not(.search-reports--theme2) .search-reports-filter-actions {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
  }
  .search-reports:not(.search-reports--theme2) .search-reports-filter-actions__spacer {
    visibility: hidden;
    user-select: none;
    margin-bottom: 4px;
    line-height: 1.2;
    min-height: 1.2em;
  }
  .search-reports:not(.search-reports--theme2) .search-reports-filter-actions__btn {
    display: flex;
    align-items: center;
    height: 38px;
  }
  .search-reports:not(.search-reports--theme2) .search-reports-filter-actions__btn .btn {
    margin: 0;
    height: 38px;
    display: inline-flex;
    align-items: center;
  }
  .search-reports-card-header.card-header {
    padding-top: 2px;
    padding-bottom: 0;
  }
  .search-reports-card-header h2,
  .search-reports-card-header h4 {
    font-size: 16px !important;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .search-reports .align-items-center {
    margin-top: 3px;
  }
  .search-reports.search-reports--theme2 .card .card-body {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-left: 0;
    padding-right: 15px;
  }
  .search-reports:not(.search-reports--theme2) .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 10px !important;
    padding-left: 0;
  }
  .search-reports .reports-folder-layout__main {
    padding-top: 10px;
    padding-right: 0;
  }
  .sticky-stock-table .rt-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) {
    text-align: center !important;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child {
    text-align: right !important;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) .rt-resizable-header-content {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child).-cursor-pointer .rt-resizable-header-content {
    padding-right: 2em;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child .rt-resizable-header-content {
    text-align: right;
    width: 100%;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) {
    text-align: center;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:last-child {
    text-align: right;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) > * {
    max-width: 100%;
    min-width: 0;
  }
  ${getStickyStockTableStickyColumnCss()}
  .search-reports .inventory-table-wrap {
    min-width: 0;
    max-width: 100%;
  }
  .search-reports .reports-folder-layout {
    min-height: 420px;
  }
  .dropdown-menu.dtiq-reports-row-actions-menu {
    z-index: 9999 !important;
    min-width: 160px;
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: auto !important;
    box-shadow: none !important;
  }
  .dropdown-menu.dtiq-reports-row-actions-menu .dropdown-item {
    display: block;
    width: 100%;
    text-align: left;
    cursor: pointer;
  }
  body.white-content .dropdown-menu.dtiq-reports-row-actions-menu {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }
  body.white-content .dropdown-menu.dtiq-reports-row-actions-menu .dropdown-item {
    color: #212529;
  }
  body:not(.white-content) .dropdown-menu.dtiq-reports-row-actions-menu {
    background: #27293d;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
  body:not(.white-content) .dropdown-menu.dtiq-reports-row-actions-menu .dropdown-item {
    color: rgba(255, 255, 255, 0.85);
  }
  body:not(.white-content) .dropdown-menu.dtiq-reports-row-actions-menu .dropdown-item:hover,
  body:not(.white-content) .dropdown-menu.dtiq-reports-row-actions-menu .dropdown-item:focus {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.08);
  }
  @media (max-width: 991.98px) {
    .search-reports .inventory-table-wrap {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-x: contain;
    }
    .search-reports .inventory-table-wrap .table-scroll-wrapper {
      overflow-x: auto !important;
      overflow-y: visible !important;
      -webkit-overflow-scrolling: touch;
    }
    .search-reports .sticky-stock-table .rt-table {
      min-width: 880px;
    }
    .search-reports.search-reports--theme2 .search-reports-table-card .card-body {
      overflow-x: hidden;
    }
  }
`;

const ReportsCards = ({
  isTheme2,
  filters,
  table,
  folderSidebar,
  folderCollapsed,
}) => {
  const mainContent = (
    <>
      <div className="search-reports-filters">{filters}</div>
      {table}
    </>
  );

  const layout = (
    <div
      className={classNames("reports-folder-layout", {
        "reports-folder-layout--collapsed": folderCollapsed,
      })}
    >
      {folderSidebar}
      <div className="reports-folder-layout__main">{mainContent}</div>
    </div>
  );

  return (
    <>
      <style>{SEARCH_REPORTS_PAGE_STYLES(isTheme2)}</style>
      {isTheme2 ? (
        <Card className="search-reports-table-card mt-0">
          <CardBody>{layout}</CardBody>
        </Card>
      ) : (
        <Card className="mt-0">
          <CardBody>{layout}</CardBody>
        </Card>
      )}
    </>
  );
};

export default ReportsCards;
